import React, { useEffect, useState } from 'react';
import { app } from '../firebase';
import { getFirestore, collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import './Dash.css';
import NavBar from '../Components/NavBar';
import LeftBar from '../Components/LeftBar';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function DashboardComp() {
  const db = getFirestore(app);
  const [metrics, setMetrics] = useState({
    totalDrivers: 0,
    pendingOrders: 0,
    completedOrders: 0,
    totalClients: 0,
    unpaidInvoices: 0,
    totalOrdersToday: 0,
  });

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        // Total Drivers
        const driversSnap = await getDocs(collection(db, 'drivers'));
        const totalDrivers = driversSnap.size;

        // Total Clients
        const clientsSnap = await getDocs(collection(db, 'clients'));
        const totalClients = clientsSnap.size;

        // Orders
        const ordersSnap = await getDocs(collection(db, 'Orders'));
        let pendingOrders = 0;
        let completedOrders = 0;
        let unpaidInvoices = 0;
        let totalOrdersToday = 0;
        const today = new Date();
        ordersSnap.forEach(doc => {
          const data = doc.data();
          const orderDate = data.timestamp?.toDate();
          if (data.status === 'Pending') pendingOrders++;
          if (data.status === 'Completed') completedOrders++;
          if (data.paymentStatus === 'Unpaid' || data.paymentStatus === 'Invoice Sent') unpaidInvoices++;
          if (orderDate && orderDate.toDateString() === today.toDateString()) totalOrdersToday++;
        });

        setMetrics({
          totalDrivers,
          pendingOrders,
          completedOrders,
          totalClients,
          unpaidInvoices,
          totalOrdersToday,
        });
      } catch (err) {
        console.error('Error fetching dashboard metrics:', err);
      }
    };

    fetchMetrics();
  }, [db]);

  const cardStyle = {
    minHeight: '120px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: '600',
    fontSize: '1.4rem'
  };

  return (

        <div className="p-4">
          <Row className="g-4 mb-4">
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Total Drivers: {metrics.totalDrivers}
              </Card>
            </Col>
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Pending Orders: {metrics.pendingOrders}
              </Card>
            </Col>
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Completed Orders: {metrics.completedOrders}
              </Card>
            </Col>
          </Row>

          <Row className="g-4 mb-4">
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Total Clients: {metrics.totalClients}
              </Card>
            </Col>
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Unpaid Invoices: {metrics.unpaidInvoices}
              </Card>
            </Col>
            <Col md={4}>
              <Card style={{ ...cardStyle, backgroundColor: '#304259' }}>
                Orders Today: {metrics.totalOrdersToday}
              </Card>
            </Col>
          </Row>

        </div>
  )
}

export default DashboardComp;